import HttpRequest from './http_request'

class ConfigProvider extends HttpRequest {
  constructor() {
    // api api
    super(process.env.VUE_APP_ENDPOINT + 'admission/api/')
  }

  //===========================================================================
  //ConfigYear
  async getYearByLevelIds(level_id) {
    const { data } = await this.get('/', {
      function: 'get-config',
      table: 'YEAR',
      where: [{
        LEVEL_ID: level_id
      }]
    })
    return data
  }

  async getYears() {
    const { data } = await this.get('/', {
      function: 'get-config',
      table: 'YEAR',
      order: [{
        START_DATE: 'DESC',
      }]
    })
    return data
  }

  async saveYears({ year, semester, admit_date, start_date, level_id }) {
    const { data } = await this.create('/', {
      function: 'set-config',
      table: 'YEAR',
      set: {
        YEAR: year,
        SEMESTER: semester,
        ADMIT_DATE: admit_date,
        START_DATE: start_date,
        LEVEL_ID: level_id,
      }
    })
    return data
  }
  async editYears({ year_id, year, semester, admit_date, start_date, level_id }) {
    const { data } = await this.create('/', {
      function: 'set-config',
      table: 'YEAR',
      set: {
        YEAR_ID: year_id,
        YEAR: year,
        SEMESTER: semester,
        ADMIT_DATE: admit_date,
        START_DATE: start_date,
        LEVEL_ID: level_id,
      }
    })
    return data
  }
  async deleteYears({ year_id }) {
    const { data } = await this.delete('/', {
      function: 'delete-config',
      table: 'YEAR',
      where: {
        YEAR_ID: year_id,
      }
    })
    return data
  }

  //===========================================================================
  //ConfigFacultyBankAccount
  async getFacultyBankAccounts() {
    const { data } = await this.get('/', {
      function: 'get-config',
      table: 'FACULTY_BANK_ACCOUNT_VIEW',
      order: [{
        FACULTY_ID: 'ASC',
        BANK_CODE: 'ASC',
      }]
    })
    return data
  }
  async saveFacultyBankAccounts({ id, level_id, faculty_id, bank_info_th, bank_info_en, bank_code, service_charge }) {
    const { data } = await this.create('/', {
      function: 'set-config',
      table: 'FACULTY_BANK_ACCOUNT',
      set: {
        ID: id,
        LEVEL_ID: level_id,
        FACULTY_ID: faculty_id,
        BANK_INFO_TH: bank_info_th,
        BANK_INFO_EN: bank_info_en,
        BANK_CODE: bank_code,
        SERVICE_CHARGE: service_charge,
      }
    })
    return data
  }
  async editFacultyBankAccounts({ id, level_id, faculty_id, bank_info_th, bank_info_en, bank_code, service_charge }) {
    const { data } = await this.create('/', {
      function: 'set-config',
      table: 'FACULTY_BANK_ACCOUNT',
      set: {
        ID: id,
        LEVEL_ID: level_id,
        FACULTY_ID: faculty_id,
        BANK_INFO_TH: bank_info_th,
        BANK_INFO_EN: bank_info_en,
        BANK_CODE: bank_code,
        SERVICE_CHARGE: service_charge,
      }
    })
    return data
  }
  async deleteFacultyBankAccounts({ id }) {
    const { data } = await this.delete('/', {
      function: 'delete-config',
      table: 'FACULTY_BANK_ACCOUNT',
      where: {
        ID: id,
      }
    })
    return data
  }

  //===========================================================================
  //ConfigRound
  async getFilteredRounds({ year_id }) {
    const { data } = await this.get('/', {
      function: 'get-config',
      table: 'ROUND_VIEW',
      where: [{ YEAR_ID: year_id }],
      order: [{
        ROUND_NUMBER: 'DESC',
        ROUND_ID: 'DESC',
      }]
    })
    return data
  }

  async saveRound({ year_id, round_number, round_name_th, round_name_en, start_date, end_date, check_clearing_house }) {
    const { data } = await this.create('/', {
      function: 'set-config',
      table: 'ROUND',
      set: {
        YEAR_ID: year_id,
        ROUND_NUMBER: round_number,
        NAME_TH: round_name_th,
        NAME_EN: round_name_en,
        START_DATE: start_date,
        END_DATE: end_date,
        CHECK_CLEARING_HOUSE: check_clearing_house,
      }
    })
    return data
  }

  async editRound({ round_id, year_id, round_number, round_name_th, round_name_en, start_date, end_date, check_clearing_house }) {
    const { data } = await this.create('/', {
      function: 'set-config',
      table: 'ROUND',
      set: {
        ROUND_ID: round_id,
        YEAR_ID: year_id,
        ROUND_NUMBER: round_number,
        NAME_TH: round_name_th,
        NAME_EN: round_name_en,
        START_DATE: start_date,
        END_DATE: end_date,
        CHECK_CLEARING_HOUSE: check_clearing_house,
      }
    })
    return data
  }

  async deleteRounds({ id }) {
    const { data } = await this.delete('/', {
      function: 'delete-config',
      table: 'ROUND',
      where: {
        ROUND_ID: id,
      }
    })
    return data
  }

  //===========================================================================
  //ConfigProject
  async getFilteredProjects({ year_id }) {
    const { data } = await this.get('/', {
      function: 'get-config',
      table: 'PROJECT_VIEW',
      where: [{ YEAR_ID: year_id }],
      order: [{
        PROJECT_ID: 'DESC',
      }]
    });
    return data;
  }

  async getFilteredProjectsByGroup({ group_id }) {
    const { data } = await this.get('/', {
      function: 'get-config',
      table: 'PROJECT_VIEW',
      where: [{ GROUP_ID: group_id }],
      order: [{
        PROJECT_ID: 'DESC',
      }]
    });
    return data;
  }

  async saveProject({
    round_id, project_code, project_name_th, project_name_en, number_of_ranks, application_fee,
    start_application_date, end_application_date, start_application_pay_date, end_application_pay_date,
    start_confirm_date, end_confirm_date, start_confirm_pay_date, end_confirm_pay_date,
    applicant_can_upload_document, enabled,
  }) {
    const { data } = await this.create('/', {
      function: 'set-config',
      table: 'PROJECT',
      set: {
        ROUND_ID: round_id,
        PROJECT_CODE: project_code,
        NAME_TH: project_name_th,
        NAME_EN: project_name_en,
        NUMBER_OF_RANKS: number_of_ranks,
        APPLICATION_FEE: application_fee,
        START_APPLICATION_DATE: start_application_date,
        END_APPLICATION_DATE: end_application_date,
        START_APPLICATION_PAY_DATE: start_application_pay_date,
        END_APPLICATION_PAY_DATE: end_application_pay_date,
        START_CONFIRM_DATE: start_confirm_date,
        END_CONFIRM_DATE: end_confirm_date,
        START_CONFIRM_PAY_DATE: start_confirm_pay_date,
        END_CONFIRM_PAY_DATE: end_confirm_pay_date,
        APPLICANT_CAN_UPLOAD_DOCUMENT: applicant_can_upload_document,
        ENABLED: enabled,
      }
    })
    return data
  }

  async editProject({
    round_id, project_id, project_code, project_name_th, project_name_en, number_of_ranks, application_fee,
    start_application_date, end_application_date, start_application_pay_date, end_application_pay_date,
    start_confirm_date, end_confirm_date, start_confirm_pay_date, end_confirm_pay_date,
    applicant_can_upload_document, enabled,
  }) {
    const { data } = await this.create('/', {
      function: 'set-config',
      table: 'PROJECT',
      set: {
        ROUND_ID: round_id,
        PROJECT_ID: project_id,
        PROJECT_CODE: project_code,
        NAME_TH: project_name_th,
        NAME_EN: project_name_en,
        NUMBER_OF_RANKS: number_of_ranks,
        APPLICATION_FEE: application_fee,
        START_APPLICATION_DATE: start_application_date,
        END_APPLICATION_DATE: end_application_date,
        START_APPLICATION_PAY_DATE: start_application_pay_date,
        END_APPLICATION_PAY_DATE: end_application_pay_date,
        START_CONFIRM_DATE: start_confirm_date,
        END_CONFIRM_DATE: end_confirm_date,
        START_CONFIRM_PAY_DATE: start_confirm_pay_date,
        END_CONFIRM_PAY_DATE: end_confirm_pay_date,
        APPLICANT_CAN_UPLOAD_DOCUMENT: applicant_can_upload_document,
        ENABLED: enabled,
      }
    })
    return data
  }

  async copyProject({
    round_id, from_project_id, project_code, project_name_th, project_name_en, number_of_ranks, application_fee,
    start_application_date, end_application_date, start_application_pay_date, end_application_pay_date,
    start_confirm_date, end_confirm_date, start_confirm_pay_date, end_confirm_pay_date,
    applicant_can_upload_document, enabled,
  }) {
    const { data } = await this.create('/', {
      function: 'copy-project',
      from_PROJECT_ID: from_project_id,
      set: {
        ROUND_ID: round_id,
        PROJECT_CODE: project_code,
        NAME_TH: project_name_th,
        NAME_EN: project_name_en,
        NUMBER_OF_RANKS: number_of_ranks,
        APPLICATION_FEE: application_fee,
        START_APPLICATION_DATE: start_application_date,
        END_APPLICATION_DATE: end_application_date,
        START_APPLICATION_PAY_DATE: start_application_pay_date,
        END_APPLICATION_PAY_DATE: end_application_pay_date,
        START_CONFIRM_DATE: start_confirm_date,
        END_CONFIRM_DATE: end_confirm_date,
        START_CONFIRM_PAY_DATE: start_confirm_pay_date,
        END_CONFIRM_PAY_DATE: end_confirm_pay_date,
        APPLICANT_CAN_UPLOAD_DOCUMENT: applicant_can_upload_document,
        ENABLED: enabled,
      }
    })
    return data
  }

  async deleteProjects({ id }) {
    const { data } = await this.delete('/', {
      function: 'delete-config',
      table: 'PROJECT',
      where: {
        PROJECT_ID: id,
      }
    })
    return data
  }

  async getProjectGroup({ round_id }) {
    const { data } = await this.get('/', {
      function: 'get-config',
      table: 'PROJECT_GROUP_VIEW',
      where: [{ ROUND_ID: round_id }],
    });
    return data;
  }

  async addNewProjectGroup({ name_en, name_th, round_id }) {
    const { data } = await this.create('/', {
      function: 'set-config',
      table: 'PROJECT_GROUP',
      set: {
        NAME_EN: name_en,
        NAME_TH: name_th,
        ROUND_ID: round_id,
      }
    });
    return data;
  }

  async deleteProjectGroup({ id }) {
    const { data } = await this.delete('/', {
      function: 'delete-config',
      table: 'PROJECT_GROUP',
      where: {
        ID: id,
      }
    })
    return data
  }

  async editGroupOfProject({ project_id, group_id }) {
    const { data } = await this.create('/', {
      function: 'set-config',
      table: 'PROJECT',
      set: {
        PROJECT_ID: project_id,
        GROUP_ID: group_id,
      }
    })
    return data
  }

  //===========================================================================
  //ConfigCurriculum
  async getBranches() {
    const { data } = await this.get('/', {
      function: 'get-view',
      table: 'REGISTRAR_BRANCH',
    });
    return data;
  }

  async getCurriculumById({ curriculum_id }) {
    const { data } = await this.get('/', {
      function: 'get-config',
      table: 'CURRICULUM_VIEW',
      where: [{ CURRICULUM_ID: curriculum_id }],
    });
    return data;
  }

  async getFilteredCurriculums({ year_id }) {
    const { data } = await this.get('/', {
      function: 'get-config',
      table: 'CURRICULUM_VIEW',
      where: [{ YEAR_ID: year_id }],
      order: [{
        CURRICULUM_ID: 'DESC',
      }],
      // order: [{
      //   ROUND_NUMBER: 'ASC',
      //   PROJECT_CODE: 'ASC',
      //   FACULTY_NAME_TH: 'ASC',
      //   CURRICULUM_SHORT_NAME_TH: 'ASC',
      // }]
    });
    return data;
  }

  async getConstraints() {
    const { data } = await this.get('/', {
      function: 'get-constraint',
      table: 'CONSTRAINT',
      CONSTRAINT_TYPE: 'CURRICULUM',
      order: [{
        CONSTRAINT_ID: 'ASC',
      }]
    });
    return data;
  }

  async saveCurriculumConstraint({ CURRICULUM_ID, CONSTRAINT_ID, VALUE }) {
    const { data } = await this.create('/', {
      function: 'set-config',
      table: 'CURRICULUM_CONSTRAINT',
      set: { CURRICULUM_ID, CONSTRAINT_ID, VALUE }
    })
    return data
  }

  async deleteCurriculumConstraint({ CURRICULUM_ID, CONSTRAINT_ID }) {
    const { data } = await this.delete('/', {
      function: 'delete-config',
      table: 'CURRICULUM_CONSTRAINT',
      where: {
        CURRICULUM_ID, CONSTRAINT_ID
      }
    })
    return data
  }

  async getFilteredCurriculumConstraints({ year_id }) {
    const { data } = await this.get('/', {
      function: 'get-config',
      table: 'CURRICULUM_CONSTRAINT_VIEW',
      where: [{ YEAR_ID: year_id }],
      order: [{
        CONSTRAINT_ID: 'ASC',
      }]
    });
    return data;
  }

  async getFilteredCurriculumConstraintsByCurriculum({ curriculum_id }) {
    const { data } = await this.get('/', {
      function: 'get-config',
      table: 'CURRICULUM_CONSTRAINT_VIEW',
      where: [{ CURRICULUM_ID: curriculum_id }],
      order: [{
        CONSTRAINT_ID: 'ASC',
      }]
    });
    return data;
  }


  async saveCurriculum(curriculum) {
    const { data } = await this.create('/', {
      function: 'set-config',
      table: 'CURRICULUM',
      set: {
        PROJECT_ID: curriculum.project_id,
        MASTER_REG_FACULTY_ID: curriculum.registrar_faculty_id,
        MASTER_REG_CURRICULUM_ID: curriculum.registrar_curriculum_id,
        TCAS_PROGRAM_ID: curriculum.config_tcas_program_id,
        URL: curriculum.config_url,
        REMARK: curriculum.config_remark,
        BRANCH_ID: curriculum.config_branch_id,

        STUDY_ADMIT_TYPE_ID: curriculum.config_study_admit_type_id,
        STUDY_PLAN_ID: curriculum.config_study_plan_id,
        STUDY_CLASSES_ID: curriculum.config_study_classes_id,
        SPECIFIC_NATION_ID: curriculum.config_specific_nation_id,
      }
    })
    return data
  }

  async editCurriculum(curriculum) {
    const { data } = await this.create('/', {
      function: 'set-config',
      table: 'CURRICULUM',
      set: {
        CURRICULUM_ID: curriculum.curriculum_id,
        PROJECT_ID: curriculum.project_id,
        MASTER_REG_FACULTY_ID: curriculum.registrar_faculty_id,
        MASTER_REG_CURRICULUM_ID: curriculum.registrar_curriculum_id,
        TCAS_PROGRAM_ID: curriculum.config_tcas_program_id,
        URL: curriculum.config_url,
        REMARK: curriculum.config_remark,
        BRANCH_ID: curriculum.config_branch_id,

        STUDY_ADMIT_TYPE_ID: curriculum.config_study_admit_type_id,
        STUDY_PLAN_ID: curriculum.config_study_plan_id,
        STUDY_CLASSES_ID: curriculum.config_study_classes_id,
        SPECIFIC_NATION_ID: curriculum.config_specific_nation_id,
      }
    })
    return data
  }
  async deleteCurriculum({ id }) {
    const { data } = await this.delete('/', {
      function: 'delete-config',
      table: 'CURRICULUM',
      where: {
        CURRICULUM_ID: id,
      }
    })
    return data
  }
  async saveCurriculumFile({ FILE, CURRICULUM_ID }) {
    let formData = new FormData();
    formData.append('FILE[0]', FILE);
    formData.append('function', 'upload-document-file');
    formData.append('service_type', 'config-curriculum');
    formData.append('CURRICULUM_ID', CURRICULUM_ID);
    const { data } = await this.create('/', formData)
    return data
  }
  async deleteCurriculumFile({ id }) {
    const { data } = await this.delete('/', {
      function: 'delete-document-file',
      service_type: 'config-curriculum',
      CURRICULUM_ID: id,
    })
    return data
  }

  async getExecutor() {
    const { data } = await this.get('/', {
      function: 'get-config',
      table: 'EXECUTOR',
    });
    return data;
  }

  async getExecutorRole() {
    const { data } = await this.get('/', {
      function: 'get-config',
      table: 'EXECUTOR_FACULTY_MAPPING',
    });
    return data;
  }


  async getExecutorInfo(registrar_user_id) {
    const { data } = await this.get('/', {
      function: 'get-executor-info',
      registrar_user_id: registrar_user_id,
    });
    return data;
  }


  async saveExecutor(registrar_user_id) {
    const { data } = await this.create('/', {
      function: 'set-config',
      table: 'EXECUTOR',
      set: {
        REGISTRAR_USER_ID: registrar_user_id,
      }
    })
    return data
  }

  async saveExecutorRole({ EXECUTOR_ID, LEVEL_ID, FACULTY_ID, LEVEL_SELECT, LEVEL_CONFIRM }) {
    const { data } = await this.create('/', {
      function: 'set-config',
      table: 'EXECUTOR_FACULTY_MAPPING',
      set: {
        EXECUTOR_ID, LEVEL_ID, FACULTY_ID, LEVEL_SELECT, LEVEL_CONFIRM
      }
    })
    return data
  }

  async deleteExecutor(EXECUTOR_ID) {
    const { data } = await this.delete('/', {
      function: 'delete-config',
      table: 'EXECUTOR',
      where: {
        EXECUTOR_ID: EXECUTOR_ID,
      }
    })
    return data
  }

  async deleteExecutorRole({ EXECUTOR_ID, LEVEL_ID, FACULTY_ID }) {
    const { data } = await this.delete('/', {
      function: 'delete-config',
      table: 'EXECUTOR_FACULTY_MAPPING',
      where: {
        EXECUTOR_ID, LEVEL_ID, FACULTY_ID
      }
    })
    return data
  }

  async getGatPatCriteria(round_id) {
    const { data } = await this.get('/', {
      function: 'get-niets-gat-pat-criteria',
      ROUND_ID: round_id,
    })
    return data
  }

  async saveGatPatCriteria(criteria_list) {
    const { data } = await this.post('/', {
      function: 'set-niets-gat-pat-criteria',
      criteria_list
    })
    return data
  }


  //===========================================================================
  //Moveapplicant
  async setMoveApplicant({ REGISTER_ID, PROJECT_ID_OLD, PROJECT_ID_NEW, CURRICULUM_ID_OLD, CURRICULUM_ID_NEW }) {
    const { data } = await this.update('/', {
      function: 'set-move-applicant',
      REGISTER_ID: REGISTER_ID,
      PROJECT_ID_OLD: PROJECT_ID_OLD,
      PROJECT_ID_NEW: PROJECT_ID_NEW,
      CURRICULUM_ID_OLD: CURRICULUM_ID_OLD,
      CURRICULUM_ID_NEW: CURRICULUM_ID_NEW
    })
    return data
  }
  async getUIDbyRegisterID(REGISTER_ID) {
    const { data } = await this.get('/', {
      function: 'get-UID-by-registerID',
      REGISTER_ID: REGISTER_ID,
    })
    return data
  }


  //===========================================================================
  //GenStudntId
  async setGenStudentId({ register_id, student_id, admis_year, admis_term, faculty_id, curr_id, curr2_name, level_id, study_plan_id }) {
    const { data } = await this.create('/', {
      function: 'set-gen-student-id',
      register_id: register_id,
      student_id: student_id,
      admis_year: admis_year,
      admis_term: admis_term,
      faculty_id: faculty_id,
      curr_id: curr_id,
      curr2_name: curr2_name,
      level_id: level_id,
      study_plan_id: study_plan_id
    })
    return data
  }

  async getMatriculationStatus(UID) {
    const { data } = await this.get('/', {
      function: 'get-matriculation-status',
      UID: UID,
    })
    return data
  }
}

export default ConfigProvider